<template>
  <div id="app">
    <router-view @refresh="onRefresh" />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    onRefresh() {
      // 接入接口后在此重新拉取开奖数据
    }
  }
}
</script>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-size: clamp(14px, 2.8vw + 8px, 18px);
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

body {
  margin: 0;
  width: 100%;
  overflow-x: hidden;
}

#app {
  width: 100%;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
